import React, { useRef, useContext, useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { AccordionContext } from "./AccordionContainer";
import { readExcelFile } from "../fileHandlers/ConvertFiles";
import { uploadFileInChunks } from "../apiHandlers/uploadFiles";
import { testFileOnBackend } from "../apiHandlers/testRequest";
import { FileTest } from "../Validation/FileTestClass";
import { DeleteFileButton, RowContainer } from "./SuccessContainer";
import FileDropBox from "./FileDropBox";

const FileDropBoxContainer = styled.div`
  flex: 1;
  height: auto;
  border: 0px dashed black;
  display: flex;
  justify-content: center;
  border-radius: 6px;
  align-items: center;
  cursor: pointer;
`;

const defaultProcessingState = {
  isProcessing: false,
  action: null,
  progress: 0,
};
const ExcelUploader = ({ id, dataModelId }) => {
  const [processing, setProcessing] = useState(defaultProcessingState);
  const { accordionData, setAccordionData } = useContext(AccordionContext);
  console.log(accordionData[id - 1].isSkippable);

  const fileInputRef = useRef();

  const runDroppedFileValidationTests = async (file) => {
    const fileContents = await readExcelFile(file);
    const newFileTest = new FileTest(fileContents, id);
    const testResults = newFileTest.runFileTest();

    return testResults;
  };

  const runFileTestsOnBackEnd = async (file) => {
    await uploadFileInChunks(
      file,
      dataModelId,
      accordionData[id - 1].backEndFileName,
      setProcessing
    );
    //set processing status to testing
    const updatedProcess = {
      progress: 1,
      action: "testing",
      isProcessing: true,
    };
    setProcessing(updatedProcess);
    const testResults = await testFileOnBackend(
      dataModelId,
      accordionData[id - 1].backEndFileName,
      id
    );
    return testResults;
  };

  const updateAccordionData = (fileTestResponse, file) => {
    const fileTestStatus = fileTestResponse.status;
    const updatedData = accordionData.map((item) =>
      item.id === id
        ? {
            ...item,
            file: file,
            fileContents: null,
            status: fileTestStatus,
            errorDetails:
              fileTestStatus === "Fail"
                ? fileTestResponse.testSuiteResults?.failedUnitTest.errorDetails
                : null,
            fileTestResponse: fileTestResponse,
            isUploadedOnBackend: accordionData[id - 1].testOnBackEnd,
          }
        : item
    );
    return updatedData;
  };

  const handleFile = async (file) => {
    if (file && file.name.endsWith(".xlsx")) {
      const testResults = accordionData[id - 1].testOnBackEnd
        ? await runFileTestsOnBackEnd(file)
        : await runDroppedFileValidationTests(file);
      const updatedAccordionData = updateAccordionData(testResults, file);

      setAccordionData(updatedAccordionData);
    } else {
      alert("Please provide a valid Excel file (.xlsx)");
    }
  };

  const handleSkippedFile = () => {
    const updatedAccordionData = updateAccordionData(
      { status: "Skipped" },
      { name: "Skipped file" }
    );
    setAccordionData(updatedAccordionData);
  };

  const onFileChange = async (e) => {
    const uploadedFile = e.target.files[0];
    handleFile(uploadedFile);
  };

  const onFileDrop = async (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    handleFile(droppedFile);
  };

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <FileDropBoxContainer
        onClick={openFileDialog}
        onDragOver={(e) => e.preventDefault()}
        onDrop={onFileDrop}
      >
        <FileDropBox processing={processing} accordionId={id} />
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx"
          onChange={onFileChange}
          style={{ display: "none" }}
        />
      </FileDropBoxContainer>
      {accordionData[id - 1].isSkippable && (
        <RowContainer>
          <DeleteFileButton
            style={{ marginBottom: "10px" }}
            onClick={handleSkippedFile}
          >
            Skip
          </DeleteFileButton>
        </RowContainer>
      )}
    </>
  );
};

ExcelUploader.propTypes = {
  id: PropTypes.number.isRequired,
  dataModelId: PropTypes.string.isRequired,
};

export default ExcelUploader;
